// material
import { alpha, styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar } from '@mui/material';
// components
//

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`
  }
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5)
  }
}));

const LogoStyle = styled(Box)(({ theme }) => ({
  minWidth: 240,
  [theme.breakpoints.up('sm')]: {
    minWidth: 240
  }
}));

// ----------------------------------------------------------------------

export default function VolShareNavbar() {
  return (
    <RootStyle>
      <ToolbarStyle>
        <Box sx={{ flexGrow: 0.4 }} />
        <Box>
          <Stack alignItems="center">
            <LogoStyle onClick={() => window.open('https://clickandtakeoff.com')}>
              <img src="/static/cto-image/icon/logoSimple.svg" alt="login" />
            </LogoStyle>
          </Stack>
        </Box>
      </ToolbarStyle>
    </RootStyle>
  );
}
